export default "__VITE_ASSET__B3QT4nkD__"